import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Home, About, News, Products, Contact, NotFound } from "./Pages/index";
import { Navbar, Footer } from "./Components/index";

import "./App.css";
const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route index element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="news" element={<News />} />
        <Route path="products" element={<Products />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
